import {
  type RecordClaimPaymentInput,
  type RecordClaimPaymentResult,
} from '@billing/validation/claim';
import type { UseMutationResult } from '@tanstack/react-query';
import { postRequest as post } from 'api/utils/HttpMethods';
import { useMutationQuery } from 'api/utils/queries';
import { claimQueryKeys } from './claim';
import { claimAttachmentQueryKeys } from './claimAttachment';
import { claimCommentQueryKeys } from './claimComment';

const recordClaimPayment = async (
  input: RecordClaimPaymentInput
): Promise<RecordClaimPaymentResult> => {
  const result = await post<RecordClaimPaymentResult>(
    'QBilling',
    '/action/claim/payment',
    input
  );
  if (!result) throw new Error('Payment could not be recorded.');
  return result;
};

export const useRecordClaimPayment = (): UseMutationResult<
  RecordClaimPaymentResult,
  Error,
  RecordClaimPaymentInput
> =>
  useMutationQuery<RecordClaimPaymentResult>({
    mutationFn: recordClaimPayment,
    successMessage: 'Payment recorded successfully.',
    errorMessage: 'Failed to record payment.',
    queryKey: claimQueryKeys.all,
    invalidateQueryKeys: (_data, variables) => [
      claimQueryKeys.all,
      claimAttachmentQueryKeys.byClaim(variables.claimID),
      [...claimCommentQueryKeys.byClaim(variables.claimID)],
    ],
  }) as UseMutationResult<
    RecordClaimPaymentResult,
    Error,
    RecordClaimPaymentInput
  >;
